"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bip32_path_1 = __importDefault(require("bip32-path"));
var crypto_1 = require("./crypto");
/**
 * Neo API
 *
 * @example
 */
var Neo = /** @class */ (function () {
    function Neo(transport) {
        this.transport = transport;
        transport.decorateAppAPIMethods(this, ["getAddress"], "NEO");
    }
    /**
     * Get Neo address for the given BIP 32 path.
     * @param path a path in BIP 32 format
     * @return an object with a publicKey and address
     * @example
     * neo.getAddress("44'/888'/0'/0/0").then(o => o.address)
     */
    Neo.prototype.getAddress = function (path) {
        return __awaiter(this, void 0, void 0, function () {
            var bipPath, buf, res, publicKey, scriptHash, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bipPath = bip32_path_1["default"].fromString(path).toPathArray();
                        buf = Buffer.alloc(4 * bipPath.length);
                        bipPath.forEach(function (segment, index) {
                            buf.writeUInt32BE(segment, 4 * index);
                        });
                        return [4 /*yield*/, this.transport.send(0x80, 0x04, 0, 0, buf)];
                    case 1:
                        res = _a.sent();
                        publicKey = res.toString("hex").substring(0, 130);
                        scriptHash = (0, crypto_1.getScriptHashFromPublicKey)(publicKey);
                        address = (0, crypto_1.getAddressFromScriptHash)(scriptHash);
                        return [2 /*return*/, {
                                address: address,
                                publicKey: publicKey
                            }];
                }
            });
        });
    };
    return Neo;
}());
exports["default"] = Neo;
//# sourceMappingURL=index.js.map